import { Component, Output, EventEmitter, ViewChild, Injectable } from '@angular/core';
import { ModalComponent } from './modal/modal.component';
import { TranslatorService } from '../translator/translator.service';

@Component({
    selector: 'smp-messageBox',
    template: `
<smp-modal [closeOnEscape]='false' [closeOnOutsideClick]='false' [hideCloseButton]='true'>
    <div class="modal-header-content">
        <h1>{{ title }}</h1>
    </div>
    <div class="modal-body-content">
        <h4>{{message}}</h4>
    </div>
    <div class="modal-footer-content">
        <button type="button" class="btn btn-default pull-right" data-dismiss="modal" (click)="cancel()" *ngIf="cancelButtonVisible">
            <i class="ace-icon fa fa-close bigger-110"></i>{{ cancelButtonText }}
        </button>
        <button type="button" class="btn btn-primary pull-right" (click)="success()">
            <i class="ace-icon fa fa-check bigger-110"></i>{{ successButtonText }}
        </button>
    </div>
</smp-modal>
`
})

export class MessageBoxComponent {
    @Output() onSuccess = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() onClose = new EventEmitter();

    @ViewChild(ModalComponent) private modal: ModalComponent;

    public title: string = '';
    public message: string = '';
    public cancelButtonVisible = true;
    public successButtonText: string = '';
    private cancelButtonText: string = '';

    constructor(
        private translateService: TranslatorService) {
    }

    public openYesNoBox(title: string, message: string) {
        this.setTranslation('successButtonText', 'COMMONBUTTONS_yes');
        this.setTranslation('cancelButtonText', 'COMMONBUTTONS_no');
        this.cancelButtonVisible = true;
        this.setCommonControls(title, message);
        this.modal.open();
    }

    public openOkCancelBox(title: string, message: string) {
        this.setTranslation('successButtonText', 'COMMONBUTTONS_ok');
        this.setTranslation('cancelButtonText', 'COMMONBUTTONS_cancel');
        this.cancelButtonVisible = true;
        this.setCommonControls(title, message);
        this.modal.open();
    }

    public openMessageBox(title: string, message: string) {
        this.setTranslation('successButtonText', 'COMMONBUTTONS_close');
        this.cancelButtonVisible = false;
        this.setCommonControls(title, message);
        this.modal.open();
    }

    public success() {
        this.modal.close();
        this.onSuccess.emit({});
        this.onClose.emit({});
    }

    private setCommonControls(title: string, message: string) {
        this.setTranslation('title', title);
        this.setTranslation('message', message);
    }

    private setTranslation(destination: string, translationName: string) {
        this.translateService.translate.get(translationName).subscribe(value => { this[destination] = value; });
    }

    private cancel() {
        this.modal.close();
        this.onCancel.emit({});
        this.onClose.emit({});
    }
}